class ServicoContexto {
    constructor({ api }) {
        this.api = api;
    }

    obterContextos() {
        return this.api.get("/api/contextos").then((response) => response.data);
    }

    obterContextosHabilitados() {
        return this.api
            .get("/api/contextos/habilitados")
            .then((response) => response.data);
    }

    obterContexto(id) {
        return this.api
            .get("/api/contextos/" + id)
            .then((response) => response.data);
    }
}

export default ServicoContexto;
